import React, { useState } from 'react'
import AccountAccessForgetPassword from './AccountAccessForgetPassword'
import AccountAccessJoin from './AccountAccessJoin'
import AccountAccessLoginStart from './AccountAccessLoginStart'
import AccountAccessLoginPassword from './AccountAccessLoginPassword'
import AccountAccessPartnershipLinkAccount from './AccountAccessPartnershipLinkAccount'
import AccountAccessResetPassword from './AccountAccessResetPassword'
import config from 'constants/config'
import BusinessTravellerLoginForm from 'businessTraveller/components/business-account/BusinessTravellerLoginForm'
import BusinessTravellerPasswordLoginForm from 'businessTraveller/components/business-account/BusinessTravellerPasswordLoginForm'
import AgentHubLoginForm from 'agentHub/components/agent-hub-account/AgentHubLoginForm'
import AgentHubPasswordLoginForm from 'agentHub/components/agent-hub-account/AgentHubPasswordLoginForm'

interface Props {
  mode?: App.UiAccountModalMode;
  dismissable?: boolean;
  defaultEmail?: string;
  onModeChange?: (nextMode: App.UiAccountModalMode) => void;
  resetPasswordToken?: string;
  hotelOfferDetails?: App.AccountModalOfferDetails;
}

function AccountAccessModalContent(props: Props) {
  const {
    mode,
    defaultEmail,
    onModeChange,
    resetPasswordToken,
    hotelOfferDetails,
  } = props

  const [email, setEmail] = useState<string>(defaultEmail ?? '')
  const isBusinessMode = config.businessTraveller.currentAccountMode === 'business'
  const isAgentHubMode = config.agentHub.isEnabled

  switch (mode) {
    case 'login':
    case 'tripPlannerLogin':
      if (isAgentHubMode) {
        return <AgentHubLoginForm onSubmit={setEmail} onModeChange={onModeChange} />
      } else if (isBusinessMode) {
        return <BusinessTravellerLoginForm onSubmit={setEmail} onModeChange={onModeChange} />
      } else {
        return <AccountAccessLoginStart onSubmit={setEmail} mode={mode} onModeChange={onModeChange} hotelOfferDetails={hotelOfferDetails} />
      }
    case 'loginPassword':
      if (isAgentHubMode) {
        return <AgentHubPasswordLoginForm requestedEmail={email} onModeChange={onModeChange} />
      } else if (isBusinessMode) {
        return <BusinessTravellerPasswordLoginForm requestedEmail={email} onModeChange={onModeChange} />
      } else {
        return <AccountAccessLoginPassword email={email} onModeChange={onModeChange} />
      }
    case 'join':
      return <AccountAccessJoin email={email} onModeChange={onModeChange} />
    case 'forgotPassword':
      return <AccountAccessForgetPassword email={email} onModeChange={onModeChange}/>
    case 'resetPassword':
      return <AccountAccessResetPassword token={resetPasswordToken!} />
    case 'linkPartnership':
      return <AccountAccessPartnershipLinkAccount />
    default:
      return null
  }
}

export default AccountAccessModalContent
